var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 7.34844C1.3125 6.76854 1.75322 6.29844 2.29687 6.29844C2.84053 6.29844 3.28125 6.76854 3.28125 7.34844V11.5484C3.28125 12.1283 2.84053 12.5984 2.29687 12.5984C1.75322 12.5984 1.3125 12.1283 1.3125 11.5484V7.34844Z",
    fill: "#011627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 7.23177V11.0332C3.9375 11.5635 4.21838 12.0482 4.66303 12.2854L4.69574 12.3028C5.06024 12.4972 5.46216 12.5984 5.86968 12.5984H9.42401C10.0497 12.5984 10.5883 12.1274 10.711 11.473L11.4985 7.273C11.661 6.40669 11.0398 5.59844 10.2115 5.59844H7.875V2.79844C7.875 2.02524 7.28737 1.39844 6.5625 1.39844C6.20006 1.39844 5.90625 1.71184 5.90625 2.09844V2.5651C5.90625 3.17094 5.72203 3.76044 5.38125 4.2451L4.4625 5.55177C4.12172 6.03644 3.9375 6.62593 3.9375 7.23177Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.fb1c6c3fb9687be4f9538ad557966d47.svg";
export { ForwardRef as ReactComponent };